// extracted by mini-css-extract-plugin
module.exports = {"newCardClose":"CreditCard_newCardClose__38JnL","closing_animation":"CreditCard_closing_animation__2AU4G"};